module.exports = __webpack_public_path__ + "img/rabelais.8470a537.jpg";